import { Grid, TextField } from '@material-ui/core';
import cx from 'classnames';
import AlertModalContent from 'components/common/modal/contents/AlertModalContent';
import T from 'components/common/text/T';
import PartnerModalInput from 'components/partner/PartnerModalInput';
import PartnerModalRequest from 'components/partner/PartnerModalRequest';
import PartnerModalSearch from 'components/partner/PartnerModalSearch';
import useInput from 'lib/hooks/useInput';
import { useDidUpdateEffect } from 'lib/utils';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { color } from 'styles/utils';

import {
  find_magnifier,
  find_magnifier_circle,
  icon_magnifier,
  icon_round_question,
  note_pencil_in_circle,
} from 'components/base/images';
import useFileInput from 'lib/hooks/useFileInput';

import { AppActions, FileActions, PartnerActions, UtilActions } from 'store/actionCreators';
import { useShallowAppSelector } from 'store/hooks';

import axios from 'axios';
import MuiWrapper from 'components/common/input/MuiWrapper';
import CustomSpan from 'components/common/text/CustomSpan';
import { validInputString } from 'lib/library';
import {
  IAccountTypeList,
  IPartnerData,
  IPartnerInfo,
  IPartnerProfileImage,
  IPartnerShipState,
  ISearchInfo,
} from 'lib/types/partnerTypes';
import { OffsetPagingData } from 'lib/types/sharedTypes';
import moment from 'moment';

interface ParternModalProps {
  detailPartnerGroupCode?: {
    value: string | null;
    onChange: (e: any) => void;
    setValue: (value: string) => void;
  };
  minor?: {
    value: string | null;
    onChange: (e: any) => void;
    setValue: (value: string) => void;
  };
  major?: {
    value: string | null;
    onChange: (e: any) => void;
    setValue: (value: string) => void;
  };
  updateSucessType?: {
    value: string | null;
    onChange: (e: any) => void;
    setValue: (value: string) => void;
  };
  updateUserData?: {
    value: any | null;
    onChange: (e: any) => void;
    setValue: (value: any) => void;
  };
  isDirectInput?: boolean;

  receivedRequestGroupCode?: string | null;
  prevPartnerStateProp?: number | null;
  onClosePartnerModal: () => void;
}

interface IUserInfo {
  userGroupIdx: number;
  groupCode: string;
  email: string | null;
  name: string | null;
  profileImg: string | null;
  countryName: string | null;
  stateName: number | null;
  phone: string | null;
  partnershipIdx: number;
  partnershipCode: string;
  state: number;
  currency: string;
  userTypeIdx: number;
}

/**
 * @param {ParternModalProps} { selectedPartner }
 * @return {*}
 */
function NewPartnerModalContainer({
  major,
  minor,
  detailPartnerGroupCode,
  receivedRequestGroupCode,
  prevPartnerStateProp,
  updateSucessType,
  updateUserData,
  isDirectInput = false,
  onClosePartnerModal,
}: ParternModalProps) {
  const {
    user,
    fetchPartnerSearch: { list: partnerSearchList, pagingData: partnerSearchListPagingData },
    fetchPartnerSearchSuccess,
    fetchPartnerDetail: { partnerInfo: partnerDetail },
    fetchPartnerDetailSuccess,
    fetchPartnerDetailFailure,
    registerNewParterSuccess,
    registerNewMenualParter: {
      manualPartnerInfo: { groupCode: newMenualPartnerGroupCode },
    },
    registerNewMenualParterSuccess,
    answerReceiveRequestedSuccess,
    answerReceiveRequestedFailure,
    editPartnerInfoSuccess,
    deletePartnerSuccess,
    fetchPartnerCodeSearch: { userInfo: partnerCodeSearch },
    fetchPartnerCodeSearchSuccess,
    fetchPartnerCodeSearchFailure,
    fetchCountryList: { countryList },
    fetchRegionList: { regionList },
    fetchCurrencyList: { currencyList },
    fetchPartnerImageUpload,
    fetchPartnerImageUploadSuccess,
    completeImageFileUploadSuccess,
    deletePartnerImageSuccess,
  }: {
    user: any;
    fetchPartnerSearch: { list: ISearchInfo[]; pagingData: OffsetPagingData };
    fetchPartnerSearchSuccess: boolean;
    fetchPartnerDetail: {
      partnerInfo: IPartnerInfo;
    };
    fetchPartnerDetailSuccess: boolean;
    fetchPartnerDetailFailure: boolean;
    registerNewParterSuccess: boolean;
    registerNewMenualParter: {
      manualPartnerInfo: {
        groupCode: string;
      };
    };
    registerNewMenualParterSuccess: boolean;
    answerReceiveRequestedSuccess: boolean;
    answerReceiveRequestedFailure: boolean;
    editPartnerInfoSuccess: boolean;
    deletePartnerSuccess: boolean;
    fetchPartnerCodeSearch: {
      userInfo: IUserInfo;
    };
    fetchPartnerCodeSearchSuccess: boolean;
    fetchPartnerCodeSearchFailure: boolean;
    fetchCountryList: {
      countryList: any;
    };
    fetchRegionList: {
      regionList: any;
    };
    fetchCurrencyList: {
      currencyList: any;
    };
    fetchPartnerImageUpload: any;
    fetchPartnerImageUploadSuccess: boolean;
    completeImageFileUploadSuccess: boolean;
    deletePartnerImageSuccess: boolean;
  } = useShallowAppSelector(state => ({
    user: state.user.user || {},
    fetchPartnerSearch: state.partner.partnerSearch.data || {},
    fetchPartnerSearchSuccess: state.partner.partnerSearch.success,
    fetchPartnerDetail: state.partner.partnerDetail.data || {},
    fetchPartnerDetailSuccess: state.partner.partnerDetail.success,
    fetchPartnerDetailFailure: state.partner.partnerDetail.failure,
    registerNewParterSuccess: state.partner.newPartner.success,
    registerNewMenualParter: state.partner.newMenualPartner.data || { manualPartnerInfo: {} },
    registerNewMenualParterSuccess: state.partner.newMenualPartner.success,
    answerReceiveRequestedSuccess: state.partner.answerReceiveRequested.success,
    answerReceiveRequestedFailure: state.partner.answerReceiveRequested.failure,
    editPartnerInfoSuccess: state.partner.editPartnerInfo.success,
    deletePartnerSuccess: state.partner.deletePartner.success,
    fetchPartnerCodeSearch: state.partner.partnerCodeSearch.data || {},
    fetchPartnerCodeSearchSuccess: state.partner.partnerCodeSearch.success,
    fetchPartnerCodeSearchFailure: state.partner.partnerCodeSearch.failure,
    fetchCountryList: state.util.countryList.data || {},
    fetchRegionList: state.util.regionList.data || {},
    fetchCurrencyList: state.util.currencyList.data || {},
    fetchPartnerImageUpload: state.file.partnerImageUploadUrl.data || {},
    fetchPartnerImageUploadSuccess: state.file.partnerImageUploadUrl.success,
    completeImageFileUploadSuccess: state.file.completeImageFileUpload.success,
    deletePartnerImageSuccess: state.file.deletePartnerImage.success,
  }));
  const { ipcRenderer } = window;
  const { t } = useTranslation();
  const searchBarRef = useRef<any | null>(null);

  const modalWidth = useInput(0);
  const modalHeight = useInput(0);
  const paddingBottom = useInput(0);

  const [isAcceptPartner, setIsAcceptPartner] = useState<boolean>(false);
  const keyword = useInput('');
  const prevKeyword = useInput('');
  const partnerCurrency = useInput('');
  const userTypeIdx = useInput('');

  // partner data list
  const userGroupIdx = useInput('');
  const nickName = useInput('');
  const type = useInput(1);
  const phone = useInput('');
  const phoneCode = useInput('');
  const email = useInput('');
  const fax = useInput('');
  const tel = useInput('');
  const address = useInput('');
  const currency = useInput('');
  const accountType = useInput('');
  const partnerShipIdx = useInput('');
  const country = useInput('');
  const region = useInput('');
  const groupCode = useInput('');

  const profileImage = useFileInput({
    file: null,
    name: '',
  });
  const profileIdx = useInput(null);
  const deleteProfileImageIdx = useInput(null);

  const majorClassify = useInput('');
  const minorClassify = useInput('');

  const alreadyPartner = useInput('');
  const receivedRequest = useInput(0);
  const selectedPartnerData = useInput('');

  const prevPartnerState = useInput(null);
  const [isSubmitAnswerData, setIsSubmitAnswerData] = useState<object | any>(null);

  const isSearchValue = useInput(true);
  const [isMenualUser, setIsMenualUser] = useState<boolean>(false);

  const modifyDate = useInput('');

  const isModifiy = useInput(false);

  const profileImageData: IPartnerProfileImage = {
    profileImage,
    profileIdx,
    deleteProfileImageIdx,
  };

  const partnerData: IPartnerData = {
    userGroupIdx,
    nickName,
    type,
    phone,
    phoneCode,
    email,
    fax,
    tel,
    address,
    country,
    currency,
    accountType,
    // region,
  };

  useEffect(() => {
    majorClassify.setValue(major?.value);
    minorClassify.setValue(minor?.value);
    UtilActions.fetch_country_list_request();
    UtilActions.fetch_currency_list_request();
    searchBarRef.current.focus();
  }, []);

  const classifyList = [
    {
      main: 'search',
      sub: [
        { value: 'default', modalStyle: { width: 550, height: 590, padding: 0 } },
        { value: 'exist', modalStyle: { width: 550, height: 590, padding: 0 } },
        { value: 'empty', modalStyle: { width: 550, height: 590, padding: 28 } },
      ],
    },
    {
      main: 'request',
      sub: [
        { value: 'received', modalStyle: { width: 550, height: 428, padding: 28 } },
        { value: 'waiting', modalStyle: { width: 550, height: 428, padding: 28 } },
        { value: 'new', modalStyle: { width: 550, height: 428, padding: 28 } },
      ],
    },

    {
      main: 'input',
      sub: [
        { value: 'detail', modalStyle: { width: 550, height: 590, padding: 28 } },
        { value: 'new', modalStyle: { width: 957, height: 590, padding: 28 } },
        { value: 'edit', modalStyle: { width: 957, height: 590, padding: 28 } },
      ],
    },
  ];

  const accountTypeList: IAccountTypeList[] = [
    { id: 0, type: 'group' },
    { id: 1, type: 'private' },
    { id: 2, type: 'manual' },
  ];

  const partnerShipState: IPartnerShipState[] = [
    { state: 0, value: '', text: 'normal', icon: '', code: '' },
    { state: 1, value: 'Partner', text: 'partner', icon: '', code: 'PARTNER_STATUS_PARTNER' },
    { state: 2, value: '', text: 'normal', icon: '', code: '' },
    { state: 3, value: 'Received', text: 'received', icon: '', code: 'PARTNER_STATUS_RECEIVED' },
    {
      state: 4,
      value: 'Waiting',
      text: 'waiting',
      icon: icon_round_question,
      code: 'PARTNER_STATUS_WAITING',
    },
  ];

  const noticeList: { isMenualUser: boolean; title: string; mainText: string; subText: string }[] =
    [
      {
        isMenualUser: false,
        title: t('PARTNER_DISCONNECT'),
        mainText: t('PARTNER_SYNC_DISCONNECT_MAIN_TEXT'),
        subText: t('PARTNER_SYNC_DISCONNECT_SUB_TEXT'),
      },
      {
        isMenualUser: true,
        title: t('PARTNER_DISCONNECT'),
        mainText: t('PARTNER_MENUAL_DISCONNECT_MAIN_TEXT'),
        subText: t('PARTNER_MENUAL_DISCONNECT_SUB_TEXT'),
      },
    ];

  const nonvalidatedNotice: { title: string; mainText: string; subText: string } = {
    title: t('GLOBAL_PARTNER_REQUEST'),
    mainText: t('INVALID_PARTNER_REQUEST'),
    subText: '',
  };

  const noParterNotice: { title: string; mainText: string; subText: string } = {
    title: t('GLOBAL_PARTNER_REQUEST'),
    mainText: t('INVALID_PARTNER_INFORMATION'),
    subText: '',
  };

  const alertNonvalidateRequestPartner = () => {
    AppActions.add_popup({
      isOpen: true,
      isCloseIcon: true,
      hideBackdrop: true,
      width: 570,
      title: '',
      content: (
        <AlertModalContent
          title={nonvalidatedNotice.title}
          mainText={nonvalidatedNotice.mainText}
          subText={nonvalidatedNotice.subText}
        />
      ),
      onClick() {
        return;
      },
      onCancel() {
        return;
      },
      onExit() {
        PartnerActions.set_invalid_parter_groupcode(partnerCodeSearch.groupCode);
        return;
      },
    });
  };

  const alertNoPartner = () => {
    AppActions.add_popup({
      isOpen: true,
      isCloseIcon: true,
      hideBackdrop: true,
      width: 570,
      title: '',
      content: (
        <AlertModalContent
          title={noParterNotice.title}
          mainText={noParterNotice.mainText}
          subText={noParterNotice.subText}
        />
      ),
      onClick() {
        return;
      },
      onCancel() {
        return;
      },
      onExit() {
        PartnerActions.set_invalid_parter_groupcode(detailPartnerGroupCode?.value);
        updateUserData?.setValue({ groupCode: detailPartnerGroupCode?.value });

        return;
      },
    });
  };

  const alertDisconnectPartner = (targetData: any) => {
    AppActions.add_popup({
      isOpen: true,
      isCloseIcon: true,
      width: 570,
      title: '',
      content: (
        <AlertModalContent
          title={noticeList.find(i => i.isMenualUser === targetData.isMenual)?.title}
          mainText={noticeList.find(i => i.isMenualUser === targetData.isMenual)?.mainText}
          subText={noticeList.find(i => i.isMenualUser === targetData.isMenual)?.subText}
        />
      ),
      onClick() {
        const submitData = {
          accountType: targetData.accountType,
          partnershipIdx: targetData.partnershipIdx,
          userGroupIdx: userGroupIdx.value,
          groupCode: targetData.groupCode,
        };
        updateUserData?.setValue(submitData);
        PartnerActions.delete_partner_request(submitData);
      },
      onCancel() {
        return;
      },
    });
  };

  useEffect(() => {
    if (!!majorClassify.value && !!minorClassify.value) {
      const classifiedStyle = classifyList
        .find(i => i.main === majorClassify.value)
        ?.sub.find(i => i.value === minorClassify.value)?.modalStyle;
      modalWidth.setValue(classifiedStyle?.width);
      // modalHeight.setValue(classifiedStyle?.height);
      paddingBottom.setValue(classifiedStyle?.padding);
    }
  }, [majorClassify.value, minorClassify.value]);

  useEffect(() => {
    if (!!detailPartnerGroupCode?.value) {
      // 파트너리스트에서 선택해서 진입한 경우,
      alreadyPartner.setValue(detailPartnerGroupCode.value);
    }
  }, [detailPartnerGroupCode?.value]);

  useDidUpdateEffect(() => {
    if (fetchPartnerSearchSuccess) {
      if (partnerSearchList?.length > 0) {
        majorClassify.setValue('search');
        minorClassify.setValue('exist');
      } else {
        majorClassify.setValue('search');
        minorClassify.setValue('empty');
      }
    }
  }, [fetchPartnerSearchSuccess]);

  useEffect(() => {
    if (!!receivedRequestGroupCode && prevPartnerStateProp !== null) {
      // received request 수락 클릭
      console.log('HDS] receivedRequestGroupCode && prevPartnerStateProp !== null ');
      majorClassify.setValue('request');
      minorClassify.setValue('received');
      receivedRequest.setValue(receivedRequestGroupCode);
      prevPartnerState.setValue(prevPartnerStateProp);
      isSearchValue.setValue(false);
    }
  }, [receivedRequestGroupCode, prevPartnerStateProp]);

  useDidUpdateEffect(() => {
    if (!!receivedRequest.value) {
      // 요청받은 파트너쉽idx가 존재하는 경우 유저 검색
      PartnerActions.fetch_partner_code_search_request(receivedRequest.value);
    }
  }, [receivedRequest.value]);

  useDidUpdateEffect(() => {
    if (!!fetchPartnerCodeSearchSuccess) {
      // 그룹코드 서칭을 통해, 사용자 정보 수집
      // state => 0: normal, 1: partner, 2:reject, 3:received, 4: request
      // if (!prevPartnerStateProp) {
      if (prevPartnerStateProp === null) {
        if (prevPartnerState.value !== partnerCodeSearch.state) {
          // 현재 state와 prev state 가 다른경우, 팝업
          alertNonvalidateRequestPartner();
          if (!!keyword.value) {
            PartnerActions.fetch_partner_search_request({ keyword: keyword.value });
          }
        } else if (
          partnerShipState.find(i => i.state === partnerCodeSearch.state)?.text === 'normal'
        ) {
          // new
          majorClassify.setValue('request');
          minorClassify.setValue('new');
          selectedPartnerData.setValue(partnerCodeSearch);
        } else if (
          partnerShipState.find(i => i.state === partnerCodeSearch.state)?.text === 'partner'
        ) {
          // Already Partner
          majorClassify.setValue('input');
          minorClassify.setValue('detail');
          alreadyPartner.setValue(partnerCodeSearch.groupCode);
        } else if (
          partnerShipState.find(i => i.state === partnerCodeSearch.state)?.text === 'received'
        ) {
          // Received Request
          majorClassify.setValue('request');
          minorClassify.setValue('received');
          selectedPartnerData.setValue(partnerCodeSearch);
        } else if (
          partnerShipState.find(i => i.state === partnerCodeSearch.state)?.text === 'waiting'
        ) {
          // Request Waiting
          majorClassify.setValue('request');
          minorClassify.setValue('waiting');
          selectedPartnerData.setValue(partnerCodeSearch);
        } else if (
          partnerShipState.find(i => i.state === partnerCodeSearch.state)?.text === 'rejected'
        ) {
          majorClassify.setValue('request');
          minorClassify.setValue('new');
          selectedPartnerData.setValue(partnerCodeSearch);
        } else {
          console.log('________________________________________ [ ERROE] ____');
        }
      } else {
        if (partnerShipState.find(i => i.state === prevPartnerStateProp)?.text === 'received') {
          // Received Request
          // 외부에서 Props를 받은경우 (Ex> notification, dashboard에서 파트너 수락 클릭 )
          majorClassify.setValue('request');
          minorClassify.setValue('received');
          selectedPartnerData.setValue(partnerCodeSearch);
        } else if (
          partnerShipState.find(i => i.state === prevPartnerStateProp)?.text === 'partner'
        ) {
          // Already Partner
          majorClassify.setValue('input');
          minorClassify.setValue('detail');
          alreadyPartner.setValue(partnerCodeSearch.groupCode);
        }
      }
    }
  }, [fetchPartnerCodeSearchSuccess, prevPartnerStateProp]);

  useDidUpdateEffect(() => {
    if (!!fetchPartnerCodeSearchFailure) {
      // console.log('[ERROR] fetchPartnerCodeSearchFailure');
      alertNoPartner();
      onClosePartnerModal();
    }
  }, [fetchPartnerCodeSearchFailure]);

  useDidUpdateEffect(() => {
    if (!!fetchPartnerDetailFailure) {
      // console.log('[ERROR] fetchPartnerDetailFailure');
      updateSucessType?.setValue('delete');
      alertNoPartner();
      onClosePartnerModal();
    }
  }, [fetchPartnerDetailFailure]);

  useDidUpdateEffect(() => {
    // 검색어 없는경우 초기 상태로
    if (!keyword.value) {
      majorClassify.setValue('search');
      minorClassify.setValue('default');
    }
  }, [keyword.value]);

  useEffect(() => {
    if (!!alreadyPartner.value) {
      // 선택 된 파트너가 존재하는 경우,
      // PartnerActions.fetch_partner_detail_request({ groupCode: alreadyPartner.value });
      PartnerActions.fetch_partner_detail_request(alreadyPartner.value);
    }
  }, [alreadyPartner.value]);

  useDidUpdateEffect(() => {
    if (fetchPartnerDetailSuccess) {
      if (!!isModifiy.value) {
        updateUserData?.setValue({ ...partnerDetail, modifyDate: moment().unix() });
      }
      isSearchValue.setValue(false);
      nickName.setValue(partnerDetail.name === null ? '' : partnerDetail.name);
      type.setValue(partnerDetail.userTypeIdx === null ? '' : partnerDetail.userTypeIdx);
      phone.setValue(partnerDetail.phone === null ? '' : partnerDetail.phone);
      phoneCode.setValue(partnerDetail.phonecode === null ? '' : partnerDetail.phonecode);
      email.setValue(partnerDetail.email === null ? '' : partnerDetail.email);
      fax.setValue(partnerDetail.fax === null ? '' : partnerDetail.fax);
      tel.setValue(partnerDetail.tel === null ? '' : partnerDetail.tel);
      address.setValue(partnerDetail.address === null ? '' : partnerDetail.address);
      profileImage.setValue(partnerDetail.profileImg === null ? null : partnerDetail.profileImg);
      currency.setValue(partnerDetail.currency === null ? '' : partnerDetail.currency);
      accountType.setValue(partnerDetail.accountType === null ? '' : partnerDetail.accountType);
      partnerShipIdx.setValue(
        partnerDetail.partnershipIdx === null ? '' : partnerDetail.partnershipIdx,
      );
      userGroupIdx.setValue(partnerDetail.userGroupIdx === null ? '' : partnerDetail.userGroupIdx);
      country.setValue(partnerDetail.countryId === null ? '' : partnerDetail.countryId);
      // region.setValue(partnerDetail.statesId === null ? '' : partnerDetail.statesId);
      groupCode.setValue(partnerDetail.groupCode === null ? '' : partnerDetail.groupCode);
      profileIdx.setValue(partnerDetail.profileIdx === null ? '' : partnerDetail.profileIdx);

      majorClassify.setValue('input');
      minorClassify.setValue('detail');

      if (!!partnerDetail.accountType) {
        setIsMenualUser(
          accountTypeList.find((i: any) => i.id === partnerDetail.accountType)?.type === 'manual',
        );
      } else {
        //accountType.value가 없는 경우, new로 간주
        setIsMenualUser(true);
      }
    }
  }, [fetchPartnerDetailSuccess, isModifiy.value]);

  useDidUpdateEffect(() => {
    if (answerReceiveRequestedSuccess) {
      if (isAcceptPartner) {
        alreadyPartner.setValue(isSubmitAnswerData.reqGroupCode);
        isModifiy.setValue(true);
      } else {
        onClosePartnerModal();
      }
    }
  }, [answerReceiveRequestedSuccess]);

  useDidUpdateEffect(() => {
    if (answerReceiveRequestedFailure) {
      alertNonvalidateRequestPartner();
      onClosePartnerModal();
    }
  }, [answerReceiveRequestedFailure]);

  useDidUpdateEffect(() => {
    if (registerNewParterSuccess) {
      updateSucessType?.setValue('request');
      onClosePartnerModal();
    }
  }, [registerNewParterSuccess]);

  useDidUpdateEffect(() => {
    if (registerNewMenualParterSuccess) {
      if (isDirectInput) onClosePartnerModal();
      alreadyPartner.setValue(newMenualPartnerGroupCode);
      if (!!profileImage.value?.file) {
        // 파일 변경
        const submitData = {
          groupCode: newMenualPartnerGroupCode,
          fileName: profileImage.value.name,
          fileSize: profileImage.value.size,
        };
        FileActions.fetch_partner_image_upload_request(submitData);
      } else {
        isModifiy.setValue(true);
      }
    }
  }, [registerNewMenualParterSuccess, isDirectInput]);

  useDidUpdateEffect(() => {
    if (deletePartnerSuccess) {
      updateSucessType?.setValue('delete');
      isModifiy.setValue(true);
      onClosePartnerModal();

      if (ipcRenderer) {
        ipcRenderer.send('setPartnerList', {});
      }
    }
  }, [deletePartnerSuccess]);

  useDidUpdateEffect(() => {
    if (editPartnerInfoSuccess) {
      if (!!profileImage.value?.file) {
        // 파일 변경
        const submitData = {
          groupCode: groupCode.value,
          fileName: profileImage.value.name,
          fileSize: profileImage.value.size,
        };
        FileActions.fetch_partner_image_upload_request(submitData);
      } else if (!profileImage.value?.file && !!deleteProfileImageIdx.value) {
        // file delete 있는 경우
        const submitData = {
          groupCode: groupCode.value,
          profileIdx: profileIdx.value,
        };
        FileActions.delete_partner_image_request(submitData);
      } else {
        isModifiy.setValue(true);
        PartnerActions.fetch_partner_detail_request(alreadyPartner.value);
      }

      if (ipcRenderer) {
        ipcRenderer.send('setPartnerList', {});
      }
    }
  }, [editPartnerInfoSuccess]);

  useDidUpdateEffect(() => {
    if (fetchPartnerImageUploadSuccess) {
      fileUpload(fetchPartnerImageUpload, profileImage.value, profileIdx.value, groupCode.value);
    }
  }, [fetchPartnerImageUploadSuccess]);

  useDidUpdateEffect(() => {
    if (deletePartnerImageSuccess || completeImageFileUploadSuccess) {
      majorClassify.setValue('input');
      minorClassify.setValue('detail');
      isModifiy.setValue(true);
      PartnerActions.fetch_partner_detail_request(alreadyPartner.value);
    }
    // TO DO - 파일 업로드 실패
  }, [deletePartnerImageSuccess, completeImageFileUploadSuccess]);

  // 파트너 생성화면으로 바로 들어왔을 때 처리
  useEffect(() => {
    if (isDirectInput) {
      isSearchValue.setValue(false);
    }
  }, [isDirectInput]);

  const handleSearchParter = () => {
    if (!!keyword.value) {
      const checkText = validInputString(keyword.value);
      keyword.setValue(checkText);
      PartnerActions.fetch_partner_search_request({ keyword: checkText });
    }
  };

  const handleSelectPartnerSearchList = (selected: any) => {
    prevPartnerState.setValue(selected.state);
    prevKeyword.setValue(keyword.value);
    PartnerActions.fetch_partner_code_search_request(selected.groupCode);
  };

  const handleSubmitAnswerReceivedRequest = (data: any) => {
    if (data.state === 1) {
      setIsAcceptPartner(true);
    } else {
      setIsAcceptPartner(false);
    }

    const submitData = {
      partnershipIdx: data.partnershipIdx,
      reqGroupCode: data.groupCode,
      reqEmail: data.email,
      state: data.state,
      userTypeIdx: data.userTypeIdx,
      currency: !!user?.currencyCode ? user?.currencyCode : 'USD',
      userGroupIdx: data.userGroupIdx,
    };
    setIsSubmitAnswerData(submitData);
    updateSucessType?.setValue('new');
    PartnerActions.answer_receive_requested_request(submitData);
  };

  const handleSubmitPartnerData = (data: any) => {
    if (minorClassify.value === 'edit') {
      let submitData = {};

      if (accountTypeList.find((i: any) => i.id === accountType.value)?.type === 'manual') {
        submitData = {
          accountType: accountType.value,
          partnershipIdx: partnerShipIdx.value,
          userGroupIdx: userGroupIdx.value,
          userTypeIdx: data.type,
          tel: data.tel,
          fax: data.fax,
          currency: data.currency,
          email: data.email,
          phonecode: !data.phoneCode ? null : data.phoneCode,
          name: data.nickName,
          phone: data.phone,
          address: data.address,
          countryId: !data.country ? null : data.country,
        };
      } else {
        submitData = {
          email: data.email,
          accountType: accountType.value,
          partnershipIdx: partnerShipIdx.value,
          userTypeIdx: data.type,
          tel: data.tel,
          fax: data.fax,
          currency: data.currency,
          address: data.address,
        };
      }
      updateSucessType?.setValue('edit');
      PartnerActions.edit_partner_info_request(submitData);
    }

    if (minorClassify.value === 'new') {
      const submitData = {
        userTypeIdx: data.type,
        email: data.email,
        name: data.nickName,
        tel: data.tel,
        phone: data.phone,
        fax: data.fax,
        address: data.address,
        currency: data.currency,
        countryId: !data.country ? null : data.country,
        phonecode: !data.phoneCode ? null : data.phoneCode,
      };
      updateSucessType?.setValue('new');
      PartnerActions.register_new_menual_partner_request(submitData);
    }
  };

  const handleSubmitRegisterNewPartner = (data: any) => {
    const submitData = {
      resGroupIdx: data.userGroupIdx,
      resUserEmail: data.email,
      resGroupCode: data.groupCode,
      userTypeIdx: data.userTypeIdx,
      currency: !!user?.currencyCode ? user?.currencyCode : 'USD',
    };

    updateUserData?.setValue({ ...submitData, modifyDate: moment().unix() });
    PartnerActions.register_new_partner_request(submitData);
  };

  const handleClickGoToBack = () => {
    PartnerActions.fetch_partner_search_request({ keyword: prevKeyword.value });
  };

  const handleDeletePartner = () => {
    const partnerData = {
      accountType: accountType.value,
      partnershipIdx: partnerShipIdx.value,
      userGroupIdx: alreadyPartner.value,
      nickName: nickName.value,
      isMenual: isMenualUser,
      groupCode: groupCode.value,
    };
    alertDisconnectPartner(partnerData);
  };

  const handleClickRegisterPartner = () => {
    majorClassify.setValue('input');
    minorClassify.setValue('new');
    isSearchValue.setValue(false);
    setIsMenualUser(true);
  };

  const fileUpload = useCallback(
    async (data: any, file: any, deleteIdx: number, groupCode: string) => {
      try {
        const response = await axios({
          url: data.signedUrl,
          method: 'put',
          data: file.file,
        });
        if (response.status === 200) {
          FileActions.complete_image_file_upload_request({
            fileType: 'partner',
            data: {
              groupCode,
              profileIdx: data.profileIdx,
              isSuccess: 1,
              deleteProfileIdx: !!deleteIdx ? deleteIdx : null,
            },
          });
        }
      } catch (error) {
        FileActions.complete_image_file_upload_request({
          fileType: 'partner',
          data: {
            groupCode,
            profileIdx: data.profileIdx,
            isSuccess: 0,
          },
        });
        AppActions.show_toast({ type: 'error', message: (error as { message: string })?.message });
      }
    },
    [],
  );

  return (
    <StyledPartnerModal
      data-component-name="NewPartnerModal"
      modalHeight={modalHeight.value}
      modalWidth={modalWidth.value}
      paddingBottom={paddingBottom.value}
      modalScale={fetchPartnerCodeSearchSuccess}
    >
      {useMemo(
        () =>
          majorClassify.value === 'input' && (
            <div className="newPartnerModal__container_input_icon">
              <img src={!!isMenualUser ? note_pencil_in_circle : find_magnifier_circle} />
            </div>
          ),
        [isMenualUser, majorClassify.value],
      )}
      <div className="newPartnerModal__container_wrapper">
        <div className="newPartnerModal__container">
          {useMemo(
            () => (
              <div
                className={cx('newPartnerModal__searchbar_wrapper', {
                  isSearchbar: !!isSearchValue.value ? true : false,
                })}
              >
                <Grid container className="newPartnerModal__searchbar_box">
                  <Grid item className="partnerModalSearch__search_image">
                    <img src={find_magnifier} />
                  </Grid>
                  <Grid item className="partnerModalSearch__search_box">
                    <CustomSpan fontSize={14} fontWeight={500}>
                      {'A. '}
                      <T>SEARCH_SYNC_ID_TITLE</T>
                    </CustomSpan>
                    <MuiWrapper
                      className="partnerModalSearch__search_bar_wrapper"
                      config={{
                        borderColor: 'transparent',
                        activeBorderColor: 'transparent',
                        hoverBorderColor: 'transparent',
                      }}
                    >
                      <>
                        <TextField
                          className="radius-md partnerModalSearch__search_bar"
                          variant="outlined"
                          fullWidth
                          inputRef={searchBarRef}
                          placeholder={t('SEARCH_SYNC_ID_TITLE_PLACEHOLDER')}
                          value={keyword?.value || ''}
                          onChange={keyword?.onChange}
                          onKeyPress={e => e.key === 'Enter' && handleSearchParter()}
                        />
                        <button
                          className="btn-reset partnerModalSearch__search_btn"
                          onClick={handleSearchParter}
                        >
                          <img src={icon_magnifier} alt="search" />
                        </button>
                      </>
                    </MuiWrapper>
                  </Grid>
                </Grid>
              </div>
            ),
            [isSearchValue.value, keyword.value],
          )}
          {useMemo(
            () =>
              majorClassify.value === 'search' && (
                <PartnerModalSearch
                  majorCategory={majorClassify}
                  minorCategory={minorClassify}
                  isSearchValue={isSearchValue}
                  partnerSearchList={partnerSearchList}
                  partnerShipState={partnerShipState}
                  onClickRegisterPartner={handleClickRegisterPartner}
                  onSelectPartnerSearchList={handleSelectPartnerSearchList}
                />
              ),
            [majorClassify.value, minorClassify.value, partnerSearchList, keyword.value],
          )}

          {useMemo(
            () =>
              majorClassify.value === 'request' && (
                <PartnerModalRequest
                  selectedPartnerData={selectedPartnerData.value}
                  majorData={majorClassify}
                  minorData={minorClassify}
                  isSearchValue={isSearchValue}
                  onClickGoToBack={handleClickGoToBack}
                  onSubmitAnswerReceivedRequest={handleSubmitAnswerReceivedRequest}
                  onSubmitRegisterNewPartner={handleSubmitRegisterNewPartner}
                />
              ),
            [majorClassify.value, minorClassify.value, selectedPartnerData.value],
          )}

          {useMemo(
            () =>
              majorClassify.value === 'input' && (
                <PartnerModalInput
                  majorData={majorClassify}
                  minorData={minorClassify}
                  countryList={countryList}
                  accountTypeList={accountTypeList}
                  partnerData={partnerData}
                  profileImageData={profileImageData}
                  currencyList={currencyList}
                  onSubmitPartnerData={handleSubmitPartnerData}
                  onDeletePartner={handleDeletePartner}
                />
              ),
            [majorClassify.value, minorClassify.value, partnerData, profileImageData],
          )}
        </div>
      </div>
    </StyledPartnerModal>
  );
}

const StyledPartnerModal = styled.section<{
  modalHeight: number;
  modalWidth: number;
  paddingBottom: number;
  modalScale: boolean;
}>`
  position: relative;
  .newPartnerModal__container_input_icon {
    position: absolute;
    top: 0;
    right: 50px;
    transform: translate(0, -50%);
    z-index: 200;
  }
  .newPartnerModal__container_wrapper {
    max-height: 590px;
    /* overflow: hidden;
    position: relative; */

    .newPartnerModal__container {
      width: ${({ modalWidth }) => modalWidth && modalWidth + 'px'};

      transition: width 0.1s, height 0.1s, transform 0.1s;

      border-radius: 15px;
      padding: 30px 30px 0 30px;
      background-color: #ffffff;

      .newPartnerModal__searchbar_wrapper {
        width: 100%;
        display: none;
        height: 0px;

        &.isSearchbar {
          margin-bottom: 30px;
          height: 110px;
          display: inline-block;
        }

        .newPartnerModal__searchbar_box {
          justify-content: space-between;
          align-items: center;
          padding-bottom: 30px;
          border-bottom: 1px dashed #b5b7c1;
          background-color: #ffffff;
        }
        .partnerModalSearch__search_image {
          width: 80px;
          height: 80px;
          img {
            width: 80px;
            height: 80px;
          }
          margin-right: 20px;
        }
        .partnerModalSearch__search_box {
          width: calc(100% - 100px);
          column-gap: 15px;
          display: flex;
          flex-direction: column;
          row-gap: 15px;
          padding-top: 5px;
          .partnerModalSearch__search_bar_wrapper {
            height: 40px;
            position: relative;
            .MuiInputBase-root {
              background-color: #f4f5fa;
            }
            .partnerModalSearch__search_btn {
              display: inline-flex;
              align-items: center;
              justify-content: center;
              position: absolute;
              right: 0;
              top: 0;
              width: 40px;
              height: 40px;
              border-top-right-radius: 5px;
              border-bottom-right-radius: 5px;
              background-color: ${color.navy_blue};
            }
          }
        }
      }
    }
  }
`;

export default React.memo(NewPartnerModalContainer);
